// OPT-246: the affiliate link is remembered for 60 days, last click wins.
const KEY = "sellary.referral";
const COOKIE_MS = 60 * 24 * 3600 * 1000;
const CODE_RE = /^[a-z0-9][a-z0-9-]{2,23}$/;
// A refusal means the stored code can never work for this account: forget it.
// Anything else (network, BillingUnavailable, BillingBusy) keeps it for the next load.
const FINAL_REFUSALS = ["ReferralCodeUnknown", "SelfReferral", "ReferralWindowClosed", "AlreadyCustomer", "InvalidInput"];

const storage = () => {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
};

export function captureReferral(code, now = Date.now()) {
  const clean = String(code == null ? "" : code).trim().toLowerCase();
  const s = storage();
  if (!s || !CODE_RE.test(clean)) return false;
  s.setItem(KEY, JSON.stringify({ code: clean, at: now }));
  return true;
}

export function clearReferral() {
  const s = storage();
  if (s) s.removeItem(KEY);
}

export function storedReferral(now = Date.now()) {
  const s = storage();
  if (!s) return null;
  try {
    const v = JSON.parse(s.getItem(KEY));
    if (v && typeof v.code === "string" && typeof v.at === "number" && now - v.at < COOKIE_MS) return v.code;
  } catch (e) {
    // fall through: unreadable is the same as expired
  }
  clearReferral();
  return null;
}

let claim = null;
let claimedCode = null;
export const resetClaim = () => { claim = null; claimedCode = null; };

/**
 * Claims the stored link once per page load and shares that promise; it never rejects. A different
 * code captured later (another creator's link in the same session) is claimed on its own.
 */
export function claimStoredReferral(api) {
  const code = storedReferral();
  if (claim && (!code || code === claimedCode)) return claim;
  if (!code) return Promise.resolve(null);
  claimedCode = code;
  // Forget the code only if storage still holds the one we tried (a newer click may have replaced it).
  const forget = () => { if (storedReferral() === code) clearReferral(); };
  claim = (async () => {
    try {
      // Loaded on demand: the router and the shell import this file on every page.
      const impl = api || (await import("@/api/affiliates"));
      await impl.claimReferral(code, "link");
      forget();
    } catch (e) {
      if (e && FINAL_REFUSALS.includes(e.errorType)) forget();
    }
    return null;
  })();
  return claim;
}
